export default "__VITE_ASSET__CQfEI5TL__"